import translateLDSDestinations from "../services/translateLDSDestinations";

/**
 * @param {string} code — LDS CITYCODE / AIRPORTCODE
 * @returns {string|null} ISO-3166 alpha-2
 */
export function resolveLdsCountryCode(code) {
  const upper = String(code || "").trim().toUpperCase();
  if (!upper) return null;

  const row = translateLDSDestinations(upper);
  const fromRow = String(row?.COUNTRYCODE || "").trim().toUpperCase();
  if (/^[A-Z]{2}$/.test(fromRow)) return fromRow;

  return null;
}

/**
 * @param {string} countryCode — ISO-3166 alpha-2
 * @param {'20x15'|'24x18'|'32x24'|'w40'} [size='24x18']
 * @returns {string|null}
 */
export function resolveCountryFlagImageUrl(countryCode, size = "24x18") {
  const cc = String(countryCode || "")
    .trim()
    .toLowerCase();
  if (!/^[a-z]{2}$/.test(cc)) return null;
  return `https://flagcdn.com/${size}/${cc}.png`;
}

/**
 * @param {{ destinationCode?: string, countryCode?: string }} input
 * @param {'20x15'|'24x18'|'32x24'|'w40'} [size='24x18']
 * @returns {string|null}
 */
export function resolveDestinationFlagImageUrl(input = {}, size = "24x18") {
  const explicit = String(input.countryCode || "")
    .trim()
    .toUpperCase();
  const cc =
    (/^[A-Z]{2}$/.test(explicit) ? explicit : null) ||
    resolveLdsCountryCode(input.destinationCode);
  return resolveCountryFlagImageUrl(cc, size);
}
